import { createSlice } from "@reduxjs/toolkit";

import { type DashboardStateType } from "../interfaces";

const initialState: DashboardStateType = {
  isLoading: false,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setDashboardLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setDashboardLoading } = dashboardSlice.actions;
export default dashboardSlice.reducer;
